import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

export enum RoutesPaths {
  Auth = '/auth/login/',
  LandingPage = '/auth/'
}
export const myTheme = createMuiTheme({
  overrides: {
    MuiTypography: {
      body1: {
        fontSize: '0.8rem',
      }
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #E1EAEE',
        },
        '&:after': {
          borderBottom: '2px solid #04A1C7',
        },
        '&&&&:hover:before': {
          borderBottom: '2px solid #04A1C7',
        },
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: '#2cb8ac',
        },
      },
    },
  },
  palette: {
    primary: {
      light: '#04A1C7',
      main: '#188ec7',
      dark: '#05364b',
      contrastText: '#fff',
    },
    secondary: {
      light: '#c73c3c',
      main: '#1A4E9B',
      dark: '#00B3A1',
      contrastText: '#fff',
    },
    error: {
      light: '#c73c3c',
      main: '#1A4E9B',
      dark: '#cc2820',
      contrastText: '#fff',
    },

  },
});